<template>
  <div class='jingci'>
    <img class="img" src="@/assets/family/jingci/kv.png" alt="">
    <img class="img" src="@/assets/family/jingci/1.jpg" alt="">
    <!-- <div class="video"> -->
      <!-- <img src="@/assets/family/jingci/video.jpg" alt=""> -->
      <!-- <img src="@/assets/family/jingci/video.jpg" alt=""> -->
    <!-- </div> -->
    <div class="container">
      <img class="image" src="@/assets/family/jingci/2.png" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: 'Jingci',
  components: {
  },
  data() {
    return {
    }
  },
  computed: { },
  watch: {},
  created() {
  },
  mounted() {
  },
  methods: {
  }
}
</script>
<style lang='less' scoped>
.jingci {
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
  .img{
    vertical-align: top;
    width: 100%;
    max-width: 1920px;
  }
  .video {
    width: 100%;
    max-width: 1920px;
    text-align: center;
    img {
      width: 1437.5px;
      height: 800px;
    }
  }
}
.container {
  max-width: 1920px;
  margin: 0 auto;
  padding: 60px 220px;
  .image {
    width: 100%;
    vertical-align: top;
    display: block;
  }
}
</style>
